import * as Tooltip from "@radix-ui/react-tooltip";
import { Info } from "lucide-react";

/*
 * A dica — regra de negócio que precisa de explicação, fora do corpo da tela.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ PARÁGRAFO DE APOIO NÃO ENTRA EMBAIXO DE TÍTULO NEM DE CAMPO.             │
 * │                                                                          │
 * │ Decisão do Jonatas, repetida: a tela fica com rótulo e dado, e o que     │
 * │ precisa de explicação ("vazio é sem limite") mora aqui. Quem já sabe não │
 * │ lê de novo a cada abertura; quem não sabe passa o mouse ou o foco.       │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * O gatilho é um `button` — e não um ícone solto — para alcançar o teclado: o
 * Radix abre a dica no foco, e o `aria-label` entrega o mesmo texto a leitor de
 * tela sem depender de abrir nada.
 *
 * Provider próprio por dica: o painel tem poucas, e um provider na raiz da
 * aplicação seria uma dependência invisível de toda tela que usa este
 * componente — inclusive nos testes, que montam telas soltas.
 */
export function Dica({ texto }: { texto: string }) {
  return (
    <Tooltip.Provider delayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            aria-label={texto}
            className="inline-flex size-4 items-center justify-center rounded-full text-texto-3 hover:text-texto-2 focus-visible:text-texto"
          >
            <Info aria-hidden="true" className="size-3.5" />
          </button>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          {/*
            Acima do modal (z-57) e da confirmação (z-70): a dica de um campo
            dentro de um diálogo não pode abrir por baixo dele.
          */}
          <Tooltip.Content
            side="top"
            sideOffset={4}
            className="z-[90] max-w-[280px] rounded-controle border border-fio-forte bg-superficie-2 px-2 py-1 text-[12px] text-texto"
          >
            {texto}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
